import moment from "moment";
import { addTrailingZeros } from "@js-app/services/helpers/math";
import {
	FINISH,
	IN_PROGRESS,
	PLACED,
	REGISTRY_COMPLETED,
} from "@js-app/const/operation-statuses-ids";


export default class BillsRegistry {
	constructor(billsRegistryData) {
		this.billRegistryData = billsRegistryData
	}

	get dateTime() {
		return {
			date: moment(this.billRegistryData.created_at).format("DD.MM.YYYY"),
			time: moment(this.billRegistryData.created_at).format("HH:mm:ss"),
		}
	}

	get datePlain() {
		return this.billRegistryData.date_create;
	}

	get registryName() {
		return this.billRegistryData.name || "";
	}

	get totalSum() {
		return addTrailingZeros(
			(parseInt(this.billRegistryData.total_sum || 0) / 100).toLocaleString()
		);
	}

	get totalSumPlain() {
		return this.billRegistryData.total_sum || 0;
	}

	get totalCount() {
		return parseInt(this.billRegistryData.position_count || 0);
	}

	get status() {
		switch (this.statusPlain) {
			case "processing":
				return IN_PROGRESS;
			case "completed":
				return REGISTRY_COMPLETED;
			case "new":
			default:
				return PLACED;
		}
	}

	get statusPlain() {
		return this.billRegistryData.status || "new";
	}

	// get id() {
	// 	return this.billRegistryData.id || Math.random();
	// }

	get id() {
		if (this.billRegistryData.id) {
			return this.billRegistryData.id;
		}

		const array = new Uint32Array(1);
		window.crypto.getRandomValues(array);

		return array[0];
	}
}
